module.exports = __webpack_public_path__ + "img/edmbet-support.d1e75f99.png";